'use client';

import React from 'react';
import LegalDocumentBody from '@/components/LegalDocumentBody';

export default function ContentSafetyPolicyContent() {
  return <LegalDocumentBody pageId="contentSafety" />;
}
